import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

// saada的路由前部都加上saada前缀
export default [
  // saada充值中心
  {
    path: '/saada/purse',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-purse-index" */ '~/pages/saada/Purse/pages/index'
        )
    ),
  },
  {
    path: '/code/wallet',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-r_purse-index" */ '~/pages/saada/Purse/pages/r_index'
        )
    ),
  },
  {
    // saada三方充值引流
    path: '/saada/credit-card-recharge-activity',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-credit-card-recharge" */ '~/pages/saada/CreditCardRecharge'
        )
    ),
  },
  // saada充值中心-币商搜索
  {
    path: '/saada/purse/search',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-purse-search" */ '~/pages/saada/Purse/pages/search'
        )
    ),
  },
  // saada 币商列表页
  {
    path: '/saada/agency-list',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-agency-list" */ '~/pages/saada/Agency'
        )
    ),
  },
  // 公会长收入明细
  {
    path: '/saada/unionincomerecord',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-unionincomerecord" */ '~/pages/saada/Union/pages/unionincomerecord'
        )
    ),
  },
  // 主播收入记录明细页
  {
    path: '/saada/anchorincomerecord/:id?',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-anchorincomerecord" */ '~/pages/saada/Union/pages/anchorincomerecord'
        )
    ),
  },
  // 珍珠钱包首页
  {
    path: '/saada/wallet/home',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-Wallet-home" */ '~/pages/saada/Wallet/pages/home'
        )
    ),
  },
  // 珍珠钱包提现
  {
    path: '/saada/wallet/outCash',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-Wallet-outCash" */ '~/pages/saada/Wallet/pages/outCash'
        )
    ),
  },
  // 珍珠钱包进出账
  {
    path: '/saada/wallet/withdraw',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-Wallet-withdraw" */ '~/pages/saada/Wallet/pages/withdraw'
        )
    ),
  },
  {
    // 珍珠钱包追退款
    path: '/saada/wallet/backer-refunds',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-Wallet-backer-refunds" */ '~/pages/saada/Wallet/pages/backer-refunds'
        )
    ),
  },
  {
    // 达人数据中心
    path: '/saada/anchor/guideCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-anchor-guideCenter" */ '~/pages/saada/Anchor/pages/guideCenter'
        )
    ),
  },
  // 加入公会
  {
    path: '/saada/anchor/joinUnion',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-anchor-joinUnion" */ '~/pages/saada/Anchor/pages/joinUnion'
        )
    ),
  },
  // 创建公会
  {
    path: '/saada/UnionWelcome/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-UnionWelcome" */ '~/pages/saada/UnionWelcome'
        )
    ),
  },
  // BD邀请
  {
    path: '/saada/bd/invite',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-bd-invite" */ '~/pages/saada/BD/pages/invite'
        )
    ),
  },
  // BD中心
  {
    path: '/saada/bd/center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-bd-center" */ '~/pages/saada/BD/pages/center'
        )
    ),
  },
  // 公会中心
  {
    path: '/saada/union/center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-center" */ '~/pages/saada/Union/pages/center'
        )
    ),
  },
  // 修改公会信息页面
  {
    path: '/saada/union/edit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-edit" */ '~/pages/saada/Union/pages/edit'
        )
    ),
  },
  // 修改公会信息页面- 头像
  {
    path: '/saada/union/edit/avatar',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-edit-avatar" */ '~/pages/saada/Union/pages/edit/avatar'
        )
    ),
  },
  // 修改公会信息页面- 公会介绍
  {
    path: '/saada/union/edit/intro',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-edit-intro" */ '~/pages/saada/Union/pages/edit/intro'
        )
    ),
  },
  // 公会信息页面- 注册信息
  {
    path: '/saada/union/edit/signinfo',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-edit-signinfo" */ '~/pages/saada/Union/pages/edit/signinfo'
        )
    ),
  },
  // 主播邀请
  {
    path: '/saada/union/anchorInvite',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-anchorInvite" */ '~/pages/saada/Union/pages/anchorInvite'
        )
    ),
  },
  // 主播管理
  {
    path: '/saada/union/anchorManage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-anchorManage" */ '~/pages/saada/Union/pages/anchorManage'
        )
    ),
  },
  // 工会欢迎
  {
    path: '/saada/union/welcome',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-welcome" */ '~/pages/saada/Union/pages/welcome'
        )
    ),
  },
  // 公会长导出营收报表
  {
    path: '/saada/union/exportRevenue',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-export-revenue" */ '~/pages/saada/Union/pages/exportRevenue'
        )
    ),
  },
  {
    // 公会长的主播删除记录页
    path: '/saada/union/deleteAnchor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-deleteAnchor" */ '~/pages/saada/Union/pages/deleteAnchor'
        )
    ),
  },
  {
    // 公会长-追退款记录
    path: '/saada/union/backer-refunds',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-backer-refunds" */ '~/pages/saada/Union/pages/backer-refunds-record'
        )
    ),
  },
  {
    // 公会长-追退款详情
    path: '/saada/union/backer-refunds-detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-union-backer-refunds-detail" */ '~/pages/saada/Union/pages/backer-refunds-detail'
        )
    ),
  },
  {
    // 首充
    path: '/saada/FirstCharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-FirstCharge" */ '~/pages/saada/FirstCharge'
        )
    ),
  },
  {
    // 单独的首充规则
    path: '/saada/FirstCharge/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-FirstCharge" */ '~/pages/saada/FirstCharge/rule'
        )
    ),
  },
  {
    // 聊天收益
    path: '/saada/chat-income',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-chatIncome" */ '~/pages/saada/chatIncome'
        )
    ),
  },
  {
    // 男用户激励
    path: '/saada/manPower',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-manPower" */ '~/pages/saada/manPower'
        )
    ),
  },
  {
    // 男用户激励签到弹窗
    path: '/saada/manPower/checkInModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-manPower-checkInModal" */ '~/pages/saada/manPower/checkInModal'
        )
    ),
  },
  {
    // 达人成长中心
    path: '/saada/growth-center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-growth-center" */ '~/pages/saada/GrowthCenter'
        )
    ),
  },
  {
    // 新手任务
    path: '/saada/level-redirect',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-level-redirect" */ '~/pages/saada/levelCenter/redirect'
        )
    ),
  },
  {
    // 新手任务
    path: '/saada/new-user-task',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-newUserTask" */ '~/pages/saada/levelCenter/newUserTask'
        )
    ),
  },
  {
    // 等级中心
    path: '/saada/level-center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-levelCenter" */ '~/pages/saada/levelCenter'
        )
    ),
  },
  {
    // 等级中心规则
    path: '/saada/level-center/rules',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-levelCenter-Rules" */ '~/pages/saada/levelCenter/Rules'
        )
    ),
  },
  {
    // 等级中心规则
    path: '/saada/level-center/rules/:currentKey',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-levelCenter-Rules" */ '~/pages/saada/levelCenter/Rules'
        )
    ),
  },
  {
    // 女用户等级中心2.0
    path: '/saada/rank-center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-rank-center-level-center-page" */ '~/pages/saada/rank-center/pages/level-center-page'
        )
    ),
  },
  {
    // 女用户等级中心2.0 - 我的权益
    path: '/saada/rank-center/my-rights',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-rank-center-my-rights-page" */ '~/pages/saada/rank-center/pages/my-rights-page'
        )
    ),
  },
  {
    // 女用户等级中心2.0 - 描述页
    path: '/saada/rank-center/description',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-rank-center-level-description-page" */ '~/pages/saada/rank-center/pages/level-description-page'
        )
    ),
  },
  {
    // 认证申诉页面
    path: '/saada/certification-appeals',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-certification-appeals" */ '~/pages/saada/CertificationAppeals'
        )
    ),
  },
  {
    // 女用户工作攻略页
    path: '/saada/work-strategy',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-work-strategy" */ '~/pages/saada/WorkStrategy'
        )
    ),
  },
  {
    // 女用户 2 分钟回复活动
    path: '/saada/reply-two',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-reply-two" */ '~/pages/saada/ReplyTwo'
        )
    ),
  },
  {
    // 聊天分榜单
    path: '/saada/chat-rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-chat-rank" */ '~/pages/saada/ChatRank/home'
        )
    ),
  },
  {
    // 聊天分榜单-详情页
    path: '/saada/chat-rank-detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-chat-rank-detail" */ '~/pages/saada/ChatRank/detail'
        )
    ),
  },
  {
    // 2025 斋月活动
    path: '/saada/ramadan',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-ramadan" */ '~/pages/saada/Ramadan'
        )
    ),
  },
  {
    // 心愿单
    path: '/saada/wish',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-saada-wish" */ '~/pages/saada/Wish')
    ),
  },
  {
    // 心愿单活动
    path: '/saada/wish-activity',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-wish-activity" */ '~/pages/saada/WishActivity/main'
        )
    ),
  },
  {
    // 心愿单活动规则页
    path: '/saada/wish-activity-rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-wish-activity-rule" */ '~/pages/saada/WishActivity/rule'
        )
    ),
  },
  {
    // 推荐分榜单
    path: '/saada/rec-score-rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-rec-score-rank" */ '~/pages/saada/RecScore/home'
        )
    ),
  },
  {
    // 推荐分榜单-详情页
    path: '/saada/rec-score-detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-rec-score-detail" */ '~/pages/saada/RecScore/detail'
        )
    ),
  },
  {
    // 周卡全局弹窗
    path: '/saada/weekly-card-global',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-weekly-global" */ '~/pages/saada/WeeklyCardGlobalModal'
        )
    ),
  },
  {
    // 匿名匹配-匹配记录
    path: '/saada/anonymous-matching/match-record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-anonymous-matching-match-record" */ '~/pages/saada/AnonymousMatching/pages/MatchRecord'
        )
    ),
  },
  {
    // 匿名匹配-时间明细
    path: '/saada/anonymous-matching/time-detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-anonymous-matching-time-detail" */ '~/pages/saada/AnonymousMatching/pages/TimeDetail'
        )
    ),
  },
  {
    // 新女用户-欢迎页
    path: '/saada/female-user/welcome',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-female-user-welcome" */ '~/pages/saada/FemaleUser/Welcome'
        )
    ),
  },
  {
    // 新女用户-认证提醒页
    path: '/saada/female-user/verify-reminder',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-female-user-verify-reminder" */ '~/pages/saada/FemaleUser/VerifyReminder'
        )
    ),
  },
  {
    // 新女用户-匹配页
    path: '/saada/female-user/matching',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-female-user-matching" */ '~/pages/saada/FemaleUser/Matching'
        )
    ),
  },
  {
    // 新女用户-任务页
    path: '/saada/female-user/task',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-female-user-task" */ '~/pages/saada/FemaleUser/Task'
        )
    ),
  },
  {
    // saada币商注册
    path: '/saada/coinagency/signup',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-CoinagencySignup" */ '~/pages/saada/Coinagency/Signup'
        )
    ),
  },
  {
    // saada准币商邀请
    path: '/saada/coinagency/invitation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-CoinagencyInvitation" */ '~/pages/saada/Coinagency/Invitation'
        )
    ),
  },
  {
    // Saada分销商被邀请确认页面
    path: `/saada/hunting/inviteUser/distributor/:mid/:uuid`,
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-DistributorUserConfirm" */ '~/pages/saada/Coinagency/DistributorUserConfirm'
        )
    ),
  },
  {
    // saada币商中心，个人交易记录
    path: '/saada/coinagency/agencywallet',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-CoinagencyAgencyWallet" */ '~/pages/saada/Coinagency/AgencyWallet'
        )
    ),
  },
  {
    // saada币商充值
    path: '/saada/coinagency/recharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-CoinagencyAgencyRecharge" */ '~/pages/saada/Coinagency/AgencyRecharge'
        )
    ),
  },
  {
    // saada卖币
    path: '/saada/coinagency/sell/:restCurrency',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-CoinagencyAgencySellCoins" */ '~/pages/saada/Coinagency/SellCoins'
        )
    ),
  },
  {
    // saada选择管理分销商，分销记录
    path: '/saada/coinagency/distributor-manage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-CoinagencyDistributorManage" */ '~/pages/saada/Coinagency/DistributorManage'
        )
    ),
  },
  {
    // saada超级币商分销页面
    path: '/saada/coinagency/super-distributor-manage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-CoinagencySuperDistributorManageHighest" */ '~/pages/saada/Coinagency/DistributorManageSuper'
        )
    ),
  },
  {
    path: '/saada/coinagency/manageQuickReply',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-manageQuickReply" */ '~/pages/saada/Coinagency/pages/manageQuickReply'
        )
    ),
  },
  {
    path: '/saada/coinagency/firstRecharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-firstRecharge" */ '~/pages/saada/Coinagency/pages/firstRecharge'
        )
    ),
  },
  {
    path: '/saada/coinagency/firstRechargeRule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-firstRechargeRule" */ '~/pages/saada/Coinagency/pages/firstRechargeRule'
        )
    ),
  },
  {
    path: '/saada/coinagency/firstRechargeHow',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-firstRechargeHow" */ '~/pages/saada/Coinagency/pages/firstRechargeHow'
        )
    ),
  },
  {
    path: '/saada/coinagency/payoutAccount',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-payoutAccount" */ '~/pages/saada/Coinagency/pages/payoutAccount'
        )
    ),
  },
  {
    path: '/saada/coinagency/createPayoutAccount',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-createPayoutAccount" */ '~/pages/saada/Coinagency/pages/createPayoutAccount'
        )
    ),
  },
  {
    path: '/saada/coinagency/supportPayoutCountry',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-supportPayoutCountry" */ '~/pages/saada/Coinagency/pages/supportPayoutCountry'
        )
    ),
  },
  {
    // 币商销售数据
    path: '/saada/coinagency/sales-data',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-coinagency-sales-data" */ '~/pages/saada/Coinagency/pages/SalesData'
        )
    ),
  },
  {
    // 币商金币详情记录
    path: '/saada/coinagency/coin-detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-coinagency-coin-detail" */ '~/pages/saada/Coinagency/pages/CoinDetail'
        )
    ),
  },
  {
    // 币商新用户推荐页
    path: '/saada/coinagency/newcomer',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-coinagency-newcomer" */ '~/pages/saada/Coinagency/pages/Newcomer'
        )
    ),
  },
  {
    // 币商历史客户页
    path: '/saada/coinagency/history-customer',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-coinagency-history-customer" */ '~/pages/saada/Coinagency/pages/HistoryCustomer'
        )
    ),
  },
  {
    path: '/saada/buyCoin',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-BuyCoin-pages-BuyCoins" */ '~/pages/saada/BuyCoin/pages/BuyCoins'
        )
    ),
  },
  {
    path: '/saada/buyCoin/merchantListPage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-BuyCoin-pages-MerchantListPage" */ '~/pages/saada/BuyCoin/pages/MerchantListPage'
        )
    ),
  },
  {
    path: '/saada/buyCoin/myOrdersPage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-BuyCoin-pages-MyOrdersPage" */ '~/pages/saada/BuyCoin/pages/MyOrdersPage'
        )
    ),
  },
  {
    path: '/saada/buyCoin/orderStatusPage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-BuyCoin-pages-OrderStatusPage" */ '~/pages/saada/BuyCoin/pages/OrderStatusPage'
        )
    ),
  },
  {
    // 视频匹配-记录页
    path: '/saada/video-matching/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-video-matching-record" */ '~/pages/saada/VideoMatching/pages/record'
        )
    ),
  },
  {
    // 视频匹配-规则页
    path: '/saada/video-matching/rules',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-video-matching-rules" */ '~/pages/saada/VideoMatching/pages/rules'
        )
    ),
  },
  {
    // 闪光卡
    path: '/saada/flare',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-saada-flare" */ '~/pages/saada/Flare')
    ),
  },
  {
    // 闪光卡
    path: '/saada/flare/report',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-flare-report" */ '~/pages/saada/Flare/report'
        )
    ),
  },
  {
    // 金刚页
    path: '/saada/kingkong',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-kingkong" */ '~/pages/saada/KingKong'
        )
    ),
  },
  {
    // 深度会话列表页
    path: '/saada/deep-chat/list',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-deep-chat-list" */ '~/pages/saada/DeepChat/page/list'
        )
    ),
  },
  {
    // 深度会话规则页
    path: '/saada/deep-chat/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-deep-chat-rule" */ '~/pages/saada/DeepChat/page/rule'
        )
    ),
  },
  {
    // 快速充值页
    path: '/saada/quick-charge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-quick-charge" */ '~/pages/saada/quick-charge'
        )
    ),
  },
] as RouteConfig[]
